<template lang="pug">
  el-row(:gutter="20")
    el-col(:span="6")
      el-card.emitidos.card-totais(shadow="always" class="box-card")
        .flex
          div(v-if="valorTotalDaeEmitidos !== '0'")
            p.valor R$ {{ valorTotalDaeEmitidos }}
            p.descricao Valor total de DAEs emitidos
          div(v-else)
            p Não há DAEs emitido nesse período

    el-col(:span="6")
      el-card.card-totais.recebidos(shadow="always" class="box-card")
        .flex
          div(v-if="valorTotalDaeRecebidos")
            p.valor R$ {{ valorTotalDaeRecebidos }}
            p.descricao Valor total de DAEs recebidos
          div(v-else)
            p Não há DAE recebido nesse período

    el-col(:span="6")
      el-card.card-totais.aguardandoPagamento(shadow="always" class="box-card")
        .flex
          div(v-if="valorTotalDaeAguardandoPagamento")
            p.valor R$ {{ valorTotalDaeAguardandoPagamento }}
            p.descricao Valor total de DAEs aguardando pagamento
          div(v-else)
            p Não há DAE aguardando pagamento nesse período

    el-col(:span="6")
      el-card.card-totais.vencido(shadow="always" class="box-card")
        .flex
          div(v-if="valorTotalDaeVencido")
            p.valor R$ {{ valorTotalDaeVencido }}
            p.descricao Valor total de DAEs vencidos
          div(v-else)
            p Não há DAE vencido nesse período
</template>

<script>
import Utils from '@/utils/utils'

export default {

  props: {
    totalDaeEmitidos: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    valorTotalDaeEmitidos () {
      let valorTotal = 0
      this.totalDaeEmitidos.forEach((situacao) => {
        if (situacao.label !== 'CANCELADO') {
          valorTotal += situacao.valor
        }
      })
      return Utils.format(valorTotal)
    },
    valorTotalDaeRecebidos () {
      let valorRecebido = 0
      if (this.totalDaeEmitidos && this.totalDaeEmitidos.length > 0) {
        valorRecebido = this.totalDaeEmitidos.filter(situacao => situacao.label === 'QUITADO')
        if (valorRecebido.length > 0) {
          return Utils.format(valorRecebido[0].valor)
        }
      }
      return 0
    },
    valorTotalDaeAguardandoPagamento () {
      let valorAguardandoPagamento = 0
      if (this.totalDaeEmitidos && this.totalDaeEmitidos.length > 0) {
        valorAguardandoPagamento = this.totalDaeEmitidos.filter(situacao => situacao.label === 'AGUARDANDO_PAGAMENTO')
        if (valorAguardandoPagamento.length > 0) {
          return Utils.format(valorAguardandoPagamento[0].valor)
        }
      }
      return 0
    },
    valorTotalDaeVencido () {
      let valorVencido = 0
      if (this.totalDaeEmitidos && this.totalDaeEmitidos.length > 0) {
        valorVencido = this.totalDaeEmitidos.filter(situacao => situacao.label === 'VENCIDO')
        if (valorVencido.length > 0) {
          return Utils.format(valorVencido[0].valor)
        }
      }
      return 0
    }

  }
}
</script>

<style lang="scss" scoped>
  .card-totais {
    height: 150px;
    color: white !important;
    cursor: default !important;
    border-radius: 15px;
    p {
        color: white;
    }
    @media (max-width: 1140px) {
      .valor {
        font-size: x-large;
      }
      .descricao {
        font-size: small;
      }
    }
    @media (min-width: 1141px) {
      .valor {
        font-size: xx-large;
      }
      .descricao {
        font-size: medium;
      }
    }
  }

  .emitidos :hover {
    background-color: rgb(255, 252, 240);
  }
  .emitidos {
    border: 2px solid #F1C40F ;
    cursor: pointer;
  }

  .recebidos:hover {
    background-color: rgb(241, 255, 252);
  }
  .recebidos {
    border: 2px solid #1ABC9C;
    cursor: pointer;
  }

  .aguardandoPagamento:hover {
    background-color: rgb(239, 248, 255);
  }
  .aguardandoPagamento {
    border: 2px solid #3498DB;
    cursor: pointer;
  }

  .vencido:hover {
    background-color: rgb(255, 244, 243);
  }
  .vencido {
    border: 2px solid #E74C3C;
    cursor: pointer;
  }

  .flex {
    display: flex;
    align-items: inherit;
    justify-content: center;
    flex-direction: column;
    height: -webkit-fill-available;
  }
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/components/DaeTotais.vue